import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import MPaper from 'components/MaterialUI/MPaper';
import MGrid from 'components/MaterialUI/MGrid';
import FormInputDisplay from 'components/FormElements/FormInputDisplay';
import { shortName } from 'utils/names';
import moment from 'utils/moment';
import { orderItemTypes, orderItemTypesToCyrillic } from 'utils/orders';
import { pricingInfoToText } from 'utils/money';
import { Grid } from '@mui/material';

const OrderPaymentInvoiceCard = ({ order_item, payment_required_at, total }) => {
  const traveller = useMemo(() => {
    switch (order_item._type) {
      case orderItemTypes.AVIA:
      case orderItemTypes.RGD:
        return shortName(order_item.traveller);
      case orderItemTypes.HOTEL:
        return order_item.travellers.map((traveller) => shortName(traveller)).join(', ');
      default:
        return '';
    }
  }, [order_item?.traveller, order_item?.travellers, order_item?._type]);

  return (
    <Grid item xs={12}>
      <MPaper>
        <Grid container spacing={1}>
          <MGrid size={12} spacing={2} alignItems="center" justifyContent="space-between">
            <MGrid spacing={3} alignItems="center" justifyContent="flex-start">
              <FormInputDisplay label={'Тип'} value={orderItemTypesToCyrillic[order_item['_type']]} />
              <FormInputDisplay label={'Тревеллер'} value={traveller} />
              <FormInputDisplay label={'Выставление счета:'} value={moment(payment_required_at).format('DD.MM.YYYY')} />
              <FormInputDisplay label={'К оплате'} value={pricingInfoToText(total?.amount)} />
            </MGrid>
          </MGrid>
        </Grid>
      </MPaper>
    </Grid>
  );
};

OrderPaymentInvoiceCard.propTypes = {
  order_item: PropTypes.object,
  payment_required_at: PropTypes.string,
  total: PropTypes.object,
};

export default OrderPaymentInvoiceCard;
